<div class="p-4">
    <div class="send-quote-content mx-auto">
      @if (isTGBelowFloor()) {
        <p-message severity="error" styleClass="mb-3 w-full" [text]="'SEND_QUOTE.TG_BELOW_FLOOR_BLOCK' | translate: { currentTG: currentTGFormatted(), threshold: tgFloor }" />
      }
      <ng-container [formGroup]="form">
        <!-- SENDER -->
        <div class="mb-3">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-inbox"></i></p-inputgroup-addon>
            <p-floatlabel variant="on" class="flex-1">
              <input id="senderEmail" pInputText formControlName="senderEmail" class="w-full" />
              <label for="senderEmail">{{ "QUOTE.VENDOR_REQUESTS.REQUEST_MESSAGE.SENDER" | translate }}</label>
            </p-floatlabel>
          </p-inputgroup>
        </div>

        <!-- SEND TO RADIO BUTTONS -->
        <div class="flex gap-4 mb-3">
          <div class="flex align-items-center gap-2">
            <p-radioButton
              name="sendQuoteTo"
              [value]="false"
              [ngModel]="sendToSelf()"
              [ngModelOptions]="{ standalone: true }"
              (onClick)="onSendToSelfChange(false)"
              inputId="sendToCustomer"
            />
            <label for="sendToCustomer">
              {{ "SEND_QUOTE.SEND_QUOTE_TO_CUSTOMER" | translate }}
            </label>
          </div>
          <div class="flex align-items-center gap-2">
            <p-radioButton
              name="sendQuoteTo"
              [value]="true"
              [ngModel]="sendToSelf()"
              [ngModelOptions]="{ standalone: true }"
              (onClick)="onSendToSelfChange(true)"
              inputId="sendToSelf"
            />
            <label for="sendToSelf">
              {{ "SEND_QUOTE.SEND_QUOTE_TO_SELF" | translate }}
            </label>
          </div>
        </div>

        <!-- RECEIVER -->
        <div class="mb-3">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-envelope"></i></p-inputgroup-addon>
            <p-floatlabel variant="on" class="flex-1">
              <input id="recipientEmail" pInputText formControlName="recipientEmail" class="w-full" />
              <label for="recipientEmail">{{ "QUOTE.VENDOR_REQUESTS.REQUEST_MESSAGE.RECEIVER" | translate }} *</label>
            </p-floatlabel>
          </p-inputgroup>
          <app-core-errors [control]="form.get('recipientEmail')"></app-core-errors>
        </div>

        <!-- Add CC -->
        <div class="mb-3">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-users"></i></p-inputgroup-addon>
            <p-floatlabel variant="on" class="flex-1">
              <input
                id="ccEmails"
                pInputText
                formControlName="ccEmails"
                class="w-full"
                (keydown.enter)="addCcRecipient(); $event.preventDefault()"
                (blur)="addCcRecipient()"
              />
              <label for="ccEmails">{{ "QUOTE.VENDOR_REQUESTS.CC_DIALOG.SUB_TITLE" | translate }}</label>
            </p-floatlabel>
          </p-inputgroup>
          <app-core-errors [control]="form.get('ccEmails')"></app-core-errors>
          @if (validCcEmails.length > 0) {
            <div class="flex flex-wrap gap-2 mt-2">
              @for (email of validCcEmails; track email) {
                <p-chip [label]="email" [removable]="true" (onRemove)="removeCcRecipient(email)" />
              }
            </div>
          }
        </div>

        <!-- SUBJECT -->
        <div class="mb-3">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-file"></i></p-inputgroup-addon>
            <p-floatlabel variant="on" class="flex-1">
              <input id="subject" pInputText formControlName="subject" class="w-full" />
              <label for="subject">{{ "QUOTE.VENDOR_REQUESTS.REQUEST_MESSAGE.SUBJECT_LABEL" | translate }} *</label>
            </p-floatlabel>
          </p-inputgroup>
          <app-core-errors [control]="form.get('subject')"></app-core-errors>
        </div>

        <!-- Message with toolbar -->
        <div class="message-handler">
          <div class="section-header">
            <i class="pi pi-envelope mr-2"></i>
            <label>{{ "SEND_QUOTE.LBL_MESSAGE" | translate }}</label>
          </div>
          <ngx-editor-menu [editor]="messageEditor" [toolbar]="toolbar"></ngx-editor-menu>
          <ngx-editor class="scrollable-content" [editor]="messageEditor" formControlName="message"></ngx-editor>
          <app-core-errors [control]="form.get('message')"></app-core-errors>
        </div>

        <!-- Attach Terms Toggle -->
        <div class="flex align-items-center gap-2 mt-5 mb-3">
          <p-toggleSwitch
            [ngModel]="isToggleChecked()"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="onAttachTermsChange($event)"
          />
          <label>{{ "SEND_QUOTE.LBL_ATTACH_TERMS" | translate }}</label>
        </div>

        <!-- PDF Attachments -->
        <div class="field">
          <div class="flex align-items-center gap-2 mb-3">
            <i class="pi pi-file-pdf"></i>
            <label class="font-medium">{{ "SEND_QUOTE.ATTACHMENTS" | translate }}</label>
          </div>

          <div class="flex flex-wrap gap-2 mb-3">
            <p-chip
              [label]="pdfFileName()"
              icon="pi pi-external-link"
              styleClass="cursor-pointer"
              [pTooltip]="'SEND_QUOTE.CLICK_TO_PREVIEW' | translate"
              (click)="openPdfPreview()"
            />
            @if (isToggleChecked()) {
              <p-chip
                [label]="termsFileName()"
                icon="pi pi-external-link"
                styleClass="cursor-pointer"
                [pTooltip]="'SEND_QUOTE.CLICK_TO_PREVIEW' | translate"
                (click)="openTermsPreview()"
              />
            }
            @for (file of files; track file) {
              <p-chip [label]="file.name" [removable]="true" (onRemove)="removeFile(file)" />
            }
          </div>

          <!-- DropZone -->
          <p-fileupload
            #fileUpload
            [multiple]="true"
            [auto]="false"
            [customUpload]="true"
            accept=".docx,.xlsx,.txt,.png,.jpg,.jpeg,.pdf"
            (onSelect)="onFilesSelected($event)"
            [showUploadButton]="false"
            [showCancelButton]="false"
            styleClass="w-full"
          >
            <ng-template #header>
              <div></div>
            </ng-template>
            <ng-template #content>
              <div></div>
            </ng-template>
            <ng-template #empty>
              <div class="flex align-items-center justify-content-center flex-column p-4">
                <i class="pi pi-cloud-upload text-4xl text-secondary mb-3"></i>
                <span class="text-secondary mb-3">{{ 'SEND_QUOTE.PLH_ATTACH_FILES' | translate }}</span>
                <p-button
                  [label]="'BROWSE' | translate"
                  icon="pi pi-folder-open"
                  [outlined]="true"
                  (onClick)="fileUpload.choose()"
                />
              </div>
            </ng-template>
          </p-fileupload>
        </div>
      </ng-container>

      <!-- Actions. Suppressed when embedded: the stepper footer drives the flow instead. -->
      @if (!embedded()) {
      <div class="flex justify-content-end gap-2 mt-4">
        <p-button [label]="'ABORT' | translate" [text]="true" (onClick)="closeDialog()" />
        <p-button
          [label]="'QUOTE.DETAIL.QUOTE_INFORMATION.SEND' | translate"
          (onClick)="onSubmit()"
          [disabled]="!canSend()"
        />
      </div>
      }
    </div>
</div>
